import { render } from "./Taglist.vue?vue&type=template&id=59322981"
import script from "./Taglist.vue?vue&type=script&lang=js"
export * from "./Taglist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__